module.exports = __webpack_public_path__ + "img/guaranteeIcon5.c6a79631.png";